import type { IntlShape } from 'react-intl';
import { metersToFeet, metersToMiles } from '@alltrails/data-formatting/distanceConverters';

export const formatData = (data, precision, measurementUnit, intl: IntlShape) => {
  if (data || data === 0) {
    let formatted = intl.formatNumber(Number(data), {
      minimumFractionDigits: precision,
      maximumFractionDigits: precision
    });

    if (measurementUnit) {
      formatted = `${formatted} ${measurementUnit}`;
    }

    return formatted;
  }

  if (measurementUnit) {
    return `0 ${measurementUnit}`;
  }

  return '';
};

export const elevationFormatted = (value, metric, intl: IntlShape) => {
  if (!value && value !== 0) {
    return '--';
  }

  const [elevation, measurementType] = metric ? [value, 'm'] : [metersToFeet(value), 'ft'];
  return formatData(elevation, 0, measurementType, intl);
};

export const metersToFormattedUserUnits = (length, precision = 2, metric, intl: IntlShape) => {
  // returns a formatted string of meters to either km or mi
  const [distance, measurementType] = metric ? [length / 1000.0, 'km'] : [metersToMiles(length), 'mi'];
  return formatData(distance, precision, measurementType, intl);
};
